function pastaelUpsellOptionMatch(left, right) {
  if (left == null || right == null) return true;
  return String(left).trim().toLowerCase() === String(right).trim().toLowerCase();
}

function pastaelCartPersonaliseFormatMoney(cents) {
  if (window.Shopify?.formatMoney) {
    return window.Shopify.formatMoney(
      cents,
      window.themeVariables?.moneyFormat || window.Shopify?.money_format
    );
  }

  const amount = (Number(cents) || 0) / 100;
  try {
    return new Intl.NumberFormat(window.Shopify?.locale || document.documentElement.lang || 'en', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'GBP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(amount);
  } catch (error) {
    return `£${amount.toFixed(2).replace(/\.00$/, '')}`;
  }
}

class PastaelCartDrawerExtras {
  constructor(drawer) {
    this.drawer = drawer;
    this.cart = drawer;
    this.personaliseModals = new WeakSet();
    this.onClick = this.onClick.bind(this);
    this.onChange = this.onChange.bind(this);
    this.drawer.addEventListener('click', this.onClick);
    this.drawer.addEventListener('change', this.onChange);
    this.initUpsellCards();
    this.bindCartPersonaliseModals();
  }

  onChange(event) {
    const toggle = event.target.closest('[data-cart-gift-toggle]');
    if (toggle) {
      event.preventDefault();
      this.setGiftWrap(toggle);
      return;
    }

    if (event.target.closest('[data-upsell-swatches]') || event.target.closest('[data-upsell-sizes]')) {
      const card = event.target.closest('[data-upsell-card]');
      if (card) this.updateUpsellCardVariant(card);
    }
  }

  initUpsellCards() {
    this.drawer.querySelectorAll('[data-upsell-card]').forEach((card) => {
      const variants = this.parseUpsellVariants(card);
      const anyAvailable = variants.some((variant) => variant.available);
      if (!anyAvailable) {
        card.hidden = true;
        return;
      }

      card.hidden = false;

      const sizeGroup = card.querySelector('[data-upsell-sizes]');
      if (sizeGroup && !sizeGroup.querySelector('input[type="radio"]:checked')) {
        sizeGroup.querySelector('input[type="radio"]')?.setAttribute('checked', 'checked');
      }

      this.updateUpsellCardVariant(card, variants);
    });
  }

  parseUpsellVariants(card) {
    try {
      return JSON.parse(card.querySelector('[data-upsell-variants]')?.textContent || '[]');
    } catch (error) {
      return [];
    }
  }

  updateUpsellCardVariant(card, variants = this.parseUpsellVariants(card)) {
    const selected = {};

    card.querySelectorAll('[data-upsell-swatches] input[type="radio"]:checked, [data-upsell-sizes] input[type="radio"]:checked').forEach((input) => {
      const position = Number(input.dataset.optionPosition);
      const value = input.dataset.optionValue || input.value;
      if (position === 1) selected.option1 = value;
      if (position === 2) selected.option2 = value;
      if (position === 3) selected.option3 = value;
    });

    const sizeGroup = card.querySelector('[data-upsell-sizes]');
    const hasSizeInputs = sizeGroup && sizeGroup.querySelector('input[type="radio"]');
    if (!hasSizeInputs && card.dataset.upsellFixedSize && card.dataset.upsellFixedSizePosition) {
      const fixedPosition = Number(card.dataset.upsellFixedSizePosition);
      const fixedValue = card.dataset.upsellFixedSize;
      if (fixedPosition === 1) selected.option1 = fixedValue;
      if (fixedPosition === 2) selected.option2 = fixedValue;
      if (fixedPosition === 3) selected.option3 = fixedValue;
    }

    let variant = variants.find((item) => {
      if (selected.option1 != null && !pastaelUpsellOptionMatch(item.option1, selected.option1)) return false;
      if (selected.option2 != null && !pastaelUpsellOptionMatch(item.option2, selected.option2)) return false;
      if (selected.option3 != null && !pastaelUpsellOptionMatch(item.option3, selected.option3)) return false;
      return true;
    });

    if (!variant) {
      const colorInput = card.querySelector('[data-upsell-swatches] input[type="radio"]:checked');
      const colorValue = colorInput?.dataset?.optionValue || colorInput?.value;
      const colorPosition = Number(colorInput?.dataset?.optionPosition);
      if (colorValue) {
        variant = variants.find((item) => {
          if (colorPosition === 1) return pastaelUpsellOptionMatch(item.option1, colorValue);
          if (colorPosition === 2) return pastaelUpsellOptionMatch(item.option2, colorValue);
          if (colorPosition === 3) return pastaelUpsellOptionMatch(item.option3, colorValue);
          return (
            pastaelUpsellOptionMatch(item.option1, colorValue) ||
            pastaelUpsellOptionMatch(item.option2, colorValue) ||
            pastaelUpsellOptionMatch(item.option3, colorValue)
          );
        });
      }
    }

    const button = card.querySelector('[data-upsell-add]');
    const priceEl = card.querySelector('[data-upsell-price]');
    const labelEl = button?.querySelector('[data-upsell-add-label]');
    const imageEl = card.querySelector('[data-upsell-image]');
    if (!variant || !button) return;

    const isAvailable = Boolean(variant.available);
    const addLabel = card.dataset.upsellAddLabel || 'Add';
    const soldOutLabel = window.variantStrings?.soldOut || 'Sold out';

    button.dataset.variantId = String(variant.id);
    button.toggleAttribute('disabled', !isAvailable);
    button.classList.toggle('is-sold-out', !isAvailable);
    if (isAvailable) {
      button.removeAttribute('aria-disabled');
    } else {
      button.setAttribute('aria-disabled', 'true');
    }

    if (labelEl) {
      labelEl.textContent = isAvailable ? addLabel : soldOutLabel;
    }

    if (priceEl && variant.price != null) {
      const moneyFormat =
        window.themeVariables?.moneyFormat || window.Shopify?.money_format || '${{amount}}';
      if (window.Shopify?.formatMoney) {
        priceEl.textContent = window.Shopify.formatMoney(variant.price, moneyFormat);
      }
      priceEl.hidden = false;
    }

    if (imageEl && variant.image) {
      imageEl.src = variant.image;
      const image72 = variant.image.replace('width=144', 'width=72');
      imageEl.srcset = `${image72} 72w, ${variant.image} 144w`;
    }
  }

  setGiftWrap(toggle) {
    const card = toggle.closest('[data-gift-wrap-card]');
    if (!card) return;

    toggle.disabled = true;

    const action = toggle.checked ? this.addGiftWrap(card) : this.removeGiftWrap(card);

    action
      .catch(() => {
        toggle.checked = !toggle.checked;
      })
      .finally(() => {
        toggle.disabled = false;
      });
  }

  addGiftWrap(card) {
    const variantId = card.dataset.giftVariantId;
    if (!variantId) return Promise.reject();

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    formData.append('properties[_gift_wrap]', 'true');

    if (this.cart) {
      formData.append(
        'sections',
        this.cart.getSectionsToRender().map((section) => section.id).join(',')
      );
      formData.append('sections_url', window.location.pathname);
      this.cart.setActiveElement(document.activeElement);
    }

    config.body = formData;

    return fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) throw new Error(response.description || response.message);

        this.publishCartUpdate(response, variantId);
        this.cart.renderContents(response);
        this.focusGiftNote();
      });
  }

  removeGiftWrap(card) {
    const line = card.dataset.giftLine;
    if (!line) return this.updateCartNote('').then(() => this.refreshDrawer());

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';

    const sections = this.cart?.getSectionsToRender().map((section) => section.id) || ['cart-drawer', 'cart-icon-bubble'];

    config.body = JSON.stringify({
      line,
      quantity: 0,
      sections,
      sections_url: window.location.pathname,
    });

    return fetch(`${routes.cart_change_url}`, config)
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        if (parsedState.errors) throw new Error(parsedState.errors);

        return this.updateCartNote('').then(() => {
          this.publishCartUpdate(parsedState);
          this.renderDrawerSections(parsedState);
        });
      });
  }

  updateCartNote(note) {
    return fetch(`${routes.cart_update_url}`, {
      ...fetchConfig('javascript'),
      body: JSON.stringify({ note }),
    });
  }

  refreshDrawer() {
    return fetch(`${routes.cart_url}?section_id=cart-drawer`, { cache: 'no-store' })
      .then((response) => {
        if (!response.ok) throw new Error('Unable to refresh your cart. Please try again.');
        return response.text();
      })
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceDrawer = html.querySelector('#CartDrawer');
        const targetDrawer = document.querySelector('#CartDrawer');
        if (!sourceDrawer || !targetDrawer) throw new Error('Unable to refresh your cart. Please try again.');
        targetDrawer.innerHTML = sourceDrawer.innerHTML;

        this.initUpsellCards();
        this.bindCartPersonaliseModals();
      });
  }

  renderDrawerSections(parsedState) {
    if (!this.cart || !parsedState.sections) return;

    this.cart.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement || !parsedState.sections[section.id]) return;

      sectionElement.innerHTML = this.cart.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    if (typeof parsedState.item_count === 'number') {
      this.cart.classList.toggle('is-empty', parsedState.item_count === 0);
    }

    this.initUpsellCards();
    this.bindCartPersonaliseModals();
  }

  focusGiftNote() {
    requestAnimationFrame(() => {
      const note = this.drawer.querySelector('[data-cart-gift-note-input]');
      note?.focus();
    });
  }

  publishCartUpdate(cartData, variantId) {
    if (typeof publish !== 'function') return;

    const pubSubEvents = window.PUB_SUB_EVENTS || (typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null);
    if (!pubSubEvents) return;

    publish(pubSubEvents.cartUpdate, {
      source: 'pastael-cart-drawer-gift',
      productVariantId: variantId,
      cartData,
    });
  }

  onClick(event) {
    const personaliseRemove = event.target.closest('[data-cart-personalise-remove]');
    if (personaliseRemove) {
      event.preventDefault();
      this.removeCartPersonalise(personaliseRemove);
      return;
    }

    const personaliseOpen = event.target.closest('[data-cart-personalise-open]');
    if (personaliseOpen) {
      event.preventDefault();
      this.openCartPersonaliseModal(personaliseOpen);
      return;
    }

    const button = event.target.closest('[data-upsell-add]');
    if (!button || button.disabled || button.classList.contains('loading')) return;
    event.preventDefault();
    this.addVariant(button);
  }

  async removeCartPersonalise(button) {
    if (button.disabled || this.removingPersonalisation) return;
    const embroideryLineKey = button.dataset.embroideryLineKey;
    const group = button.closest('[data-embroidery-group]')?.dataset.embroideryGroup;
    if (!embroideryLineKey || !group) return;

    const sections = this.cart.getSectionsToRender().map((section) => section.id);
    const cartItems = this.drawer.querySelector('#CartDrawer-CartItems');
    const errors = this.drawer.querySelector('#CartDrawer-CartErrors');
    if (errors) errors.textContent = '';
    this.removingPersonalisation = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (cartItems) cartItems.inert = true;
    let cartState;

    const changeLine = async (mutation) => {
      const response = await fetch(routes.cart_change_url, {
        ...fetchConfig('javascript'),
        body: JSON.stringify({ ...mutation, sections, sections_url: window.location.pathname }),
      });
      const state = await response.json();
      if (!response.ok || state.errors || state.status) {
        throw new Error(state.description || state.message ||
          (typeof state.errors === 'string' ? state.errors : window.cartStrings.error));
      }
      return state;
    };

    try {
      cartState = await changeLine({ id: embroideryLineKey, quantity: 0 });
      const parent = cartState.items.find((item) =>
        item.properties?._pastael_embroidery_group === group && item.properties?._pastael_embroidery !== 'true'
      );
      if (parent) {
        const properties = { ...parent.properties };
        ['Letters', 'Initials', 'Font', 'Color'].forEach((key) => delete properties[key]);
        cartState = await changeLine({ id: parent.key, quantity: parent.quantity, properties });
      }

      this.cart.renderContents(cartState);
      this.publishCartUpdate(cartState);
      requestAnimationFrame(() => {
        this.drawer.querySelector(`[data-embroidery-group="${CSS.escape(group)}"] [data-cart-personalise-open]`)?.focus();
      });
    } catch (error) {
      if (cartState) {
        this.cart.renderContents(cartState);
        this.publishCartUpdate(cartState);
      }
      const currentErrors = this.drawer.querySelector('#CartDrawer-CartErrors');
      if (currentErrors) currentErrors.textContent = error.message || window.cartStrings.error;
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      if (cartItems) cartItems.inert = false;
      this.removingPersonalisation = false;
    }
  }

  bindCartPersonaliseModals() {
    this.drawer.querySelectorAll('[data-cart-personalise-modal]').forEach((modal) => {
      this.bindCartPersonaliseModal(modal);
    });
  }

  bindCartPersonaliseModal(modal) {
    if (this.personaliseModals.has(modal)) return;
    this.personaliseModals.add(modal);

    const dialog = modal.querySelector('[data-gift-set-dialog]');
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) this.closeCartPersonaliseModal(modal);
    });
    dialog?.addEventListener('close', () => {
      modal.hidden = true;
      if (modal._pastaelOriginalParent?.isConnected) {
        modal._pastaelOriginalParent.appendChild(modal);
      } else {
        modal.remove();
      }
      delete modal.dataset.portaled;
      delete modal._pastaelOriginalParent;

      const drawerOpen = this.drawer.classList.contains('active');
      document.body.classList.toggle('overflow-hidden', drawerOpen || Boolean(document.querySelector('dialog[open]')));
      if (drawerOpen) {
        const focusTarget = modal._pastaelTrigger?.isConnected
          ? modal._pastaelTrigger
          : this.drawer.querySelector('.drawer__close');
        focusTarget?.focus();
      }
      delete modal._pastaelTrigger;
    });

    modal.querySelectorAll('[data-cart-personalise-close]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.closeCartPersonaliseModal(modal);
      });
    });

    modal.querySelector('[data-cart-personalise-add]')?.addEventListener('click', (event) => {
      event.preventDefault();
      this.submitCartPersonalise(modal);
    });

    const root = modal.querySelector('[data-pastael-embroidery]');
    if (!root) return;

    try {
      root._embroideryProductData = JSON.parse(
        root.querySelector('[data-embroidery-product-json]')?.textContent || '{}'
      );
    } catch (error) {
      root._embroideryProductData = {};
    }

    root.querySelectorAll('.pastael-pdp__embroidery-fieldset').forEach((fieldset) => {
      const options = fieldset.querySelectorAll('[data-embroidery-option]');
      if (options.length > 0 && !fieldset.querySelector('[data-embroidery-option]:checked')) {
        options[0].checked = true;
      }
    });

    root.addEventListener('change', (event) => {
      if (event.target.matches('[data-embroidery-toggle], [data-embroidery-option]')) {
        this.syncCartPersonaliseEmbroidery(modal);
      }
    });

    root.querySelector('[data-embroidery-initials]')?.addEventListener('input', (event) => {
      const sanitized = String(event.target.value || '')
        .replace(/[^a-z]/gi, '')
        .slice(0, 3)
        .toUpperCase();
      if (event.target.value !== sanitized) event.target.value = sanitized;
      const count = root.querySelector('[data-embroidery-count]');
      if (count) count.textContent = `${sanitized.length}/3`;
      this.clearCartPersonaliseError(modal);
      this.updateCartPersonalisePreview(modal);
    });
  }

  openCartPersonaliseModal(trigger) {
    const dialogId = trigger.getAttribute('aria-controls');
    const modal =
      trigger.closest('.pastael-cart-drawer__item')?.querySelector('[data-cart-personalise-modal]') ||
      (dialogId ? document.getElementById(dialogId)?.closest('[data-cart-personalise-modal]') : null);
    const dialog = modal?.querySelector('[data-gift-set-dialog]');
    if (!modal || !dialog) return;

    this.bindCartPersonaliseModal(modal);
    modal._pastaelTrigger = trigger;

    if (modal.dataset.portaled !== 'true') {
      modal._pastaelOriginalParent = modal.parentElement;
      document.body.appendChild(modal);
      modal.dataset.portaled = 'true';
    }

    modal.hidden = false;

    const toggle = modal.querySelector('[data-embroidery-toggle]');
    if (toggle) toggle.checked = true;
    this.syncCartPersonaliseEmbroidery(modal);

    this.clearCartPersonaliseError(modal);

    try {
      dialog.showModal();
    } catch (error) {
      console.error('[pastael-cart-drawer] personalise showModal failed', error);
      return;
    }

    document.body.classList.add('overflow-hidden');
    Array.from(modal.querySelectorAll('[data-cart-personalise-close]'))
      .find((button) => button.getClientRects().length > 0)?.focus();
  }

  closeCartPersonaliseModal(modal) {
    const dialog = modal?.querySelector('[data-gift-set-dialog]');
    if (dialog?.open) dialog.close();
  }

  getCartPersonaliseEmbroideryOptions(root) {
    const selected = [];
    root?.querySelectorAll('[data-embroidery-option]:checked').forEach((input) => {
      const position = Number(input.dataset.embroideryOptionPosition);
      if (position > 0) selected[position - 1] = input.value;
    });
    return selected;
  }

  getCartPersonalisePreviewColor(input) {
    const configured = String(input?.dataset.embroideryColor || '').trim();
    if (configured) return configured;

    const color = String(input?.value || '').trim().toLowerCase();
    const fallback = {
      white: '#ffffff',
      yellow: '#f6d884',
      red: '#8f1b0d',
      black: '#000000',
      brown: '#574138',
      'baby blue': '#A2CFFE',
      navy: '#15144f',
      'navy blue': '#15144f',
      blue: '#15144f',
    };
    return fallback[color] || '#ffffff';
  }

  syncCartPersonaliseEmbroidery(modal) {
    const root = modal.querySelector('[data-pastael-embroidery]');
    if (!root) return null;

    const toggle = root.querySelector('[data-embroidery-toggle]');
    const panel = root.querySelector('[data-embroidery-panel]');
    const expanded = Boolean(toggle?.checked);
    const selectedOptions = this.getCartPersonaliseEmbroideryOptions(root);
    const variants = Array.isArray(root._embroideryProductData?.variants)
      ? root._embroideryProductData.variants
      : [];

    const variant =
      variants.find((item) =>
        (item.options || []).every(
          (option, index) =>
            selectedOptions[index] == null ||
            pastaelUpsellOptionMatch(option, selectedOptions[index])
        )
      ) || null;

    const variantInput = root.querySelector('[data-embroidery-variant-id]');
    if (variantInput) variantInput.value = variant?.id || '';

    if (panel) panel.hidden = !expanded;
    toggle?.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    root.classList.toggle('is-active', expanded);
    root.querySelector('[data-embroidery-collapsed-price]')?.toggleAttribute('hidden', expanded);
    root.querySelector('[data-embroidery-selected-price]')?.toggleAttribute('hidden', !expanded);

    const selectedPrice = root.querySelector('[data-embroidery-selected-price]');
    if (selectedPrice && variant?.price != null) {
      selectedPrice.textContent = pastaelCartPersonaliseFormatMoney(variant.price);
    }

    const colorInput = root.querySelector('[data-embroidery-option][data-embroidery-color]:checked');
    const colorName = root.querySelector('[data-embroidery-color-name]');
    if (colorInput && colorName) colorName.textContent = colorInput.value;

    const totalEl = modal.querySelector('[data-cart-personalise-total]');
    if (totalEl) {
      totalEl.textContent = pastaelCartPersonaliseFormatMoney(
        expanded && variant?.price != null ? variant.price : 0
      );
    }

    this.updateCartPersonalisePreview(modal);
    return variant;
  }

  updateCartPersonalisePreview(modal) {
    const preview = modal.querySelector('[data-embroidery-preview]');
    const root = modal.querySelector('[data-pastael-embroidery]');
    if (!preview || !root) return;

    const toggle = root.querySelector('[data-embroidery-toggle]');
    const initialsInput = root.querySelector('[data-embroidery-initials]');
    const initials = String(initialsInput?.value || '').trim().toUpperCase();
    const enabled = Boolean(toggle?.checked);
    const fontInput = root.querySelector('[data-embroidery-font]:checked');
    const colorInput = root.querySelector('[data-embroidery-option][data-embroidery-color]:checked');

    preview.className = preview.className
      .split(' ')
      .filter((className) => !className.startsWith('pastael-pdp__embroidery-preview--'))
      .join(' ');
    const fontHandle = fontInput?.dataset.embroideryFont || 'bodoni';
    preview.classList.add(`pastael-pdp__embroidery-preview--${fontHandle}`);
    const fontInputs = root.querySelectorAll('[data-embroidery-font]');
    const fontIndex =
      fontInput && fontInputs.length ? Array.from(fontInputs).indexOf(fontInput) : -1;
    preview.classList.toggle('pastael-pdp__embroidery-preview--font-third', fontIndex === 2);
    preview.style.setProperty(
      '--embroidery-preview-color',
      this.getCartPersonalisePreviewColor(colorInput)
    );
    preview.textContent = initials;
    preview.hidden = !enabled || initials.length === 0;
  }

  clearCartPersonaliseError(modal) {
    const error = modal.querySelector('[data-cart-personalise-error]');
    const root = modal.querySelector('[data-pastael-embroidery]');
    const embroideryError = root?.querySelector('[data-embroidery-error]');
    const initials = root?.querySelector('[data-embroidery-initials]');
    if (error) {
      error.hidden = true;
      error.textContent = '';
    }
    if (embroideryError) {
      embroideryError.hidden = true;
      embroideryError.textContent = '';
    }
    initials?.removeAttribute('aria-invalid');
  }

  showCartPersonaliseError(modal, message) {
    const error = modal.querySelector('[data-cart-personalise-error]');
    if (!error) return;
    error.textContent = message;
    error.hidden = false;
  }

  getCartPersonaliseSelection(modal) {
    const root = modal.querySelector('[data-pastael-embroidery]');
    const toggle = root?.querySelector('[data-embroidery-toggle]');
    if (!root || !toggle?.checked) {
      return { error: root?.dataset.initialsRequired || 'Choose personalisation options.' };
    }

    const initials = String(root.querySelector('[data-embroidery-initials]')?.value || '')
      .replace(/[^a-z]/gi, '')
      .slice(0, 3)
      .toUpperCase();
    if (initials.length < 1) {
      return {
        error: root.dataset.initialsRequired || 'Enter 1 to 3 letters for your embroidery.',
      };
    }

    const variant = this.syncCartPersonaliseEmbroidery(modal);
    if (!variant?.id || variant.available === false) {
      return {
        error: root.dataset.combinationUnavailable || 'This embroidery combination is unavailable.',
      };
    }

    const fontInput = root.querySelector('[data-embroidery-font]:checked');
    const colorInput = root.querySelector(
      '[data-embroidery-option][data-embroidery-color]:checked'
    );
    const font =
      fontInput?.value ||
      fontInput?.closest('label')?.querySelector('.pastael-pdp__embroidery-font-display')?.textContent ||
      '';
    const color = colorInput?.value || '';

    return {
      variantId: Number(variant.id),
      initials,
      font: String(font).trim(),
      color: String(color).trim(),
    };
  }

  getCartPersonaliseWarehouseProperties(selection) {
    if (!selection?.initials) return {};

    const properties = {
      Letters: selection.initials,
      Initials: selection.initials,
    };
    if (selection.font) properties.Font = selection.font;
    if (selection.color) properties.Color = selection.color;
    return properties;
  }

  createEmbroideryGroupId() {
    if (window.crypto?.randomUUID) return window.crypto.randomUUID();
    return `embroidery-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  }

  async submitCartPersonalise(modal) {
    if (!modal || modal.dataset.submitting === 'true') return;

    const selection = this.getCartPersonaliseSelection(modal);
    if (selection.error) {
      this.showCartPersonaliseError(modal, selection.error);
      return;
    }

    const lineKey = modal.dataset.cartLineKey;
    const parentVariantId = modal.dataset.parentVariantId;
    if (!lineKey || !parentVariantId) {
      this.showCartPersonaliseError(modal, 'Your cart has changed. Close this popup and try again.');
      return;
    }

    const groupId = modal.dataset.personaliseGroup || this.createEmbroideryGroupId();
    modal.dataset.personaliseGroup = groupId;

    const sectionIds =
      this.cart?.getSectionsToRender().map((section) => section.id).join(',') ||
      'CartDrawer,cart-icon-bubble';

    modal.dataset.submitting = 'true';
    const addButton = modal.querySelector('[data-cart-personalise-add]');
    addButton?.setAttribute('aria-disabled', 'true');
    addButton?.setAttribute('disabled', 'disabled');
    this.clearCartPersonaliseError(modal);

    const requestCart = async (url, config = {}) => {
      const response = await fetch(url, config);
      const result = await response.json();
      if (!response.ok || result.status || result.errors) {
        const errors = typeof result.errors === 'string'
          ? result.errors
          : Object.values(result.errors || {}).join(' ');
        throw new Error(result.description || result.message || errors || 'Unable to add personalisation. Please try again.');
      }
      return result;
    };
    const fetchCart = () => requestCart(`${routes.cart_url}.js`, { cache: 'no-store' });
    const hasLinkedEmbroidery = (cart) => {
      const parent = cart.items?.find((item) =>
        String(item.variant_id || item.id) === String(parentVariantId) &&
        item.properties?._pastael_embroidery_group === groupId &&
        item.properties?._pastael_embroidery !== 'true'
      );
      const embroidery = cart.items?.find((item) =>
        String(item.variant_id || item.id) === String(selection.variantId) &&
        item.properties?._pastael_embroidery_group === groupId &&
        item.properties?._pastael_embroidery === 'true'
      );
      return parent && embroidery && parent.quantity === embroidery.quantity;
    };

    try {
      let cartState = await fetchCart();
      let renderedSections;

      if (!hasLinkedEmbroidery(cartState)) {
        let parent = cartState.items?.find((item) => item.key === modal.dataset.cartLineKey);
        if (!parent) {
          const originalProperties = JSON.parse(modal.querySelector('[data-cart-line-properties]')?.textContent || '{}');
          const candidates = (cartState.items || []).filter((item) => {
            if (String(item.variant_id || item.id) !== String(parentVariantId)) return false;
            if (item.properties?._pastael_embroidery === 'true') return false;
            if (item.properties?._pastael_embroidery_group === groupId) return true;
            const properties = item.properties || {};
            return Object.keys(properties).length === Object.keys(originalProperties).length &&
              Object.entries(originalProperties).every(([key, value]) => properties[key] === value);
          });
          if (candidates.length === 1) parent = candidates[0];
        }
        if (!parent) throw new Error('Your cart has changed. Close this popup and try again.');

        const quantity = parent.quantity;
        const properties = {
          ...parent.properties,
          _pastael_embroidery_group: groupId,
          ...this.getCartPersonaliseWarehouseProperties(selection),
        };
        const changeConfig = fetchConfig('javascript');
        changeConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
        changeConfig.body = JSON.stringify({
          id: parent.key,
          quantity,
          properties,
          sections: sectionIds,
          sections_url: window.location.pathname,
        });

        const changeState = await requestCart(routes.cart_change_url, changeConfig);
        const updatedParent = changeState.items?.find((item) =>
          String(item.variant_id || item.id) === String(parentVariantId) &&
          item.properties?._pastael_embroidery_group === groupId &&
          item.properties?._pastael_embroidery !== 'true'
        );
        if (!updatedParent) throw new Error('Unable to save personalisation to this bag. Please try again.');
        modal.dataset.cartLineKey = updatedParent.key;
        modal.dataset.cartQuantity = String(updatedParent.quantity);

        const addConfig = fetchConfig('javascript');
        addConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete addConfig.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', String(selection.variantId));
        formData.append('quantity', String(updatedParent.quantity));
        formData.append('properties[Letters]', selection.initials);
        formData.append('properties[Initials]', selection.initials);
        if (selection.font) formData.append('properties[Font]', selection.font);
        if (selection.color) formData.append('properties[Color]', selection.color);
        formData.append('properties[_pastael_embroidery]', 'true');
        formData.append('properties[_pastael_embroidery_group]', groupId);
        formData.append('properties[_pastael_parent_variant]', String(parentVariantId));
        formData.append('sections', sectionIds);
        formData.append('sections_url', window.location.pathname);
        addConfig.body = formData;

        const addResult = await requestCart(routes.cart_add_url, addConfig);
        renderedSections = addResult.sections;
        cartState = await fetchCart();
        if (!hasLinkedEmbroidery(cartState)) {
          throw new Error('Personalisation was not added to your bag. Please try again.');
        }
      }

      if (renderedSections) this.cart.renderContents({ ...cartState, sections: renderedSections });
      await this.refreshDrawer();
      this.publishCartUpdate(cartState, selection.variantId);
      this.closeCartPersonaliseModal(modal);
      modal.remove();
    } catch (error) {
      this.showCartPersonaliseError(modal, error?.message || 'Unable to add personalisation.');
    } finally {
      modal.dataset.submitting = 'false';
      addButton?.removeAttribute('aria-disabled');
      addButton?.removeAttribute('disabled');
    }
  }

  addVariant(button) {
    const variantId = button.dataset.variantId;
    if (!variantId) return;

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');
    button.querySelector('.loading__spinner')?.classList.remove('hidden');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    if (this.cart) {
      formData.append(
        'sections',
        this.cart.getSectionsToRender().map((section) => section.id).join(',')
      );
      formData.append('sections_url', window.location.pathname);
      this.cart.setActiveElement(document.activeElement);
    }

    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) return;

        if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        this.publishCartUpdate(response, variantId);
        this.cart.renderContents(response);
      })
      .catch(() => {})
      .finally(() => {
        button.classList.remove('loading');
        button.removeAttribute('aria-disabled');
        button.querySelector('.loading__spinner')?.classList.add('hidden');
      });
  }
}

function initPastaelCartDrawerOverlayClose(drawer) {
  if (!drawer || drawer.pastaelOverlayCloseInit) return;

  const desktopMediaQuery = window.matchMedia('(min-width: 750px)');
  const overlay = drawer.querySelector('#CartDrawer-Overlay');
  if (!overlay) return;

  drawer.pastaelOverlayCloseInit = true;

  const hideOverlayClose = () => {
    overlay.classList.remove('is-pointer-active');
    const closeButton = overlay.querySelector('[data-overlay-close]');
    if (closeButton) closeButton.hidden = true;
  };

  drawer.addEventListener('mousemove', (event) => {
    if (!desktopMediaQuery.matches || !drawer.classList.contains('active')) {
      hideOverlayClose();
      return;
    }

    const closeButton = overlay.querySelector('[data-overlay-close]');
    if (!closeButton) return;

    const onOverlay = event.target === overlay || event.target === closeButton || overlay.contains(event.target);
    if (!onOverlay) {
      hideOverlayClose();
      return;
    }

    overlay.classList.add('is-pointer-active');
    closeButton.hidden = false;

    const bounds = overlay.getBoundingClientRect();
    closeButton.style.left = `${event.clientX - bounds.left}px`;
    closeButton.style.top = `${event.clientY - bounds.top}px`;
  });

  drawer.addEventListener('mouseleave', hideOverlayClose);

  drawer.addEventListener('click', (event) => {
    if (!event.target.closest('[data-overlay-close]')) return;
    event.preventDefault();
    event.stopPropagation();
    drawer.close();
    hideOverlayClose();
  });

  desktopMediaQuery.addEventListener('change', hideOverlayClose);
}

function initPastaelCartDrawerExtras() {
  const drawer = document.querySelector('cart-drawer.pastael-cart-drawer');
  if (!drawer) return;

  initPastaelCartDrawerOverlayClose(drawer);

  if (!drawer.pastaelExtras) {
    drawer.pastaelExtras = new PastaelCartDrawerExtras(drawer);
  }

  if (typeof initPastaelApplePayButtons === 'function') {
    requestAnimationFrame(() => initPastaelApplePayButtons());
  }
}

if (!customElements.get('pastael-cart-drawer-upsell-slider')) {
  class PastaelCartDrawerUpsellSlider extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-upsell-viewport]');
      this.track = this.querySelector('[data-upsell-track]');
      if (!this.viewport || !this.track) return;

      this.isDragging = false;
      this.startX = 0;
      this.scrollLeft = 0;
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);

      this.viewport.addEventListener('pointerdown', this.onPointerDown);
      this.viewport.addEventListener('pointermove', this.onPointerMove);
      this.viewport.addEventListener('pointerup', this.onPointerUp);
      this.viewport.addEventListener('pointercancel', this.onPointerUp);
      this.viewport.addEventListener('pointerleave', this.onPointerUp);
    }

    disconnectedCallback() {
      this.viewport?.removeEventListener('pointerdown', this.onPointerDown);
      this.viewport?.removeEventListener('pointermove', this.onPointerMove);
      this.viewport?.removeEventListener('pointerup', this.onPointerUp);
      this.viewport?.removeEventListener('pointercancel', this.onPointerUp);
      this.viewport?.removeEventListener('pointerleave', this.onPointerUp);
    }

    onPointerDown(event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (event.target.closest('[data-upsell-add], [data-upsell-swatches], [data-upsell-sizes], .swatch-input__label')) return;

      this.isDragging = true;
      this.startX = event.clientX;
      this.scrollLeft = this.viewport.scrollLeft;
      this.viewport.classList.add('is-dragging');
      this.viewport.setPointerCapture(event.pointerId);
    }

    onPointerMove(event) {
      if (!this.isDragging) return;

      event.preventDefault();
      const walk = event.clientX - this.startX;
      this.viewport.scrollLeft = this.scrollLeft - walk;
    }

    onPointerUp(event) {
      if (!this.isDragging) return;

      this.isDragging = false;
      this.viewport.classList.remove('is-dragging');

      if (this.viewport.hasPointerCapture(event.pointerId)) {
        this.viewport.releasePointerCapture(event.pointerId);
      }
    }
  }

  customElements.define('pastael-cart-drawer-upsell-slider', PastaelCartDrawerUpsellSlider);
}

document.addEventListener('DOMContentLoaded', initPastaelCartDrawerExtras);

if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
  subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
    const extras = document.querySelector('cart-drawer.pastael-cart-drawer')?.pastaelExtras;
    extras?.initUpsellCards();
    extras?.bindCartPersonaliseModals();
  });
}
